import { useTranslation } from "react-i18next";

import { useLocale } from "../../i18n";
import { PurchaseStatus, Transaction } from "./useTransactions";

const useTransactionTaxExemption = ({
  taxExemption,
  state,
}: Pick<Transaction, "taxExemption" | "state">) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const canRenderTaxExemption =
    taxExemption &&
    state !== PurchaseStatus.CANCELLED &&
    taxExemption.amountInCents !== 0;

  return canRenderTaxExemption
    ? `${t("transactions.you-save")} ${taxExemption.toFormatString(locale)}`
    : "";
};

export { useTransactionTaxExemption };
